<template>
    <div>
        <b-modal 
            no-stacking
            centered
            no-close-on-esc
            no-close-on-backdrop
            hide-header-close
            hide-footer
            v-model="kerryDropoff.show"
            size="lg"
        >
        <template slot="modal-header">
            <div slot="header" class="bg-white border-0 w-100">
                <div class="row align-items-center">
                    <div class="col-6">
                        <h3 class="mb-0">นำเข้าพัสดุ Kerry Drop off <span class="text-danger">กรุณากดรับเงินภายในวันที่สแกนรับงานก่อนเวลา 23.59น. พัสดุจึงจะถูกบันทึกเข้าระบบ</span></h3>
                    </div>
                    <div class="col-6 text-right">
                        <a :href="customDropoff.manual" v-if="customDropoff.manual" target="_blank">คู่มือการใช้งาน  </a>  
                        <a :href="customDropoff.vdoHowTo"  v-if="customDropoff.vdoHowTo" target="_blank">VDO การใช้งาน</a>
                    </div>
                </div>
            </div>
        </template>
            <card shadow type="secondary" class="m--4">
                <div class="row">
                    <div class="col-md-12">
                        <SearchTracking
                            :isLoading="kerryDropoff.isLoadingKerryDropoff"
                            isPlaceholder="TH480522KRFX7A"
                            :isError="kerryDropoff"
                            :isTracking="kerryDropoff"
                            @checkTracking="checkTrackingKerryDropoff()"
                        />
                        <div class="container-fluid px-5">
                            <div class="row">
                                <h4>รายการพัสดุ</h4>    
                            </div>
                            <div class="row">
                                <div class="scroll-table scroll-bar-pop m-h-380 scrollbar-style table-responsive">
                                    <!-- <h4 class="scroll-empty text-center">กรุณาแสกนหมายเลขพัสดุ</h4> -->
                                    <table class="table">
                                        <thead class="thead-light">
                                            <tr class="text-center">
                                                <th>#</th>
                                                <th>Tracking no.</th>
                                                <th>ผู้รับ</th>
                                                <th>รหัสไปรษณีย์</th>
                                                <th>จัดการ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-for="(item,index) in kerryOrder">
                                                <tr class="text-center table-white" :key="index">
                                                    <td>{{index + 1}}</td>
                                                    <td>{{item.dropoff_tracking_code}}</td>
                                                    <td>{{item.to.name}}</td>
                                                    <td>{{item.to.postcode}}</td>
                                                    <td>
                                                        <div class="d-flex">
                                                            <button
                                                                class="btn btn-link text-danger p-2 hvr-grow"
                                                                @click="deleteKerryOrder( item , index )"
                                                            >
                                                                <i class="far fa-trash-alt"></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="mt-4 w-100">
                                <div class="row text-center">
                                    <div class="col-12">
                                        <b-button 
                                            class="px-5 mx-4" 
                                            variant="secondary"
                                            @click="clearKerryDropoff()"
                                        > 
                                            <i class="fas fa-circle-notch fa-spin" v-if="isLoadCancelBatch"></i>
                                            ยกเลิก
                                        </b-button>
                                        <b-button
                                            class="px-5 mx-4"
                                            variant="success"
                                            @click="$emit('confirmCreateKerryDropoff' , kerryOrder)"
                                        > ยืนยัน
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </card>
        </b-modal>
    </div>
</template>

<script>
import SearchTracking from '@/components/custom/pos/SearchTracking'
import setLocalStorage from '@/constants/LocalStorageManagement'
import { createBatch , addShipment , deleteShipment , deleteBatch } from "@/axios/kerryDropoff.js";
import { showErrorModal } from "@/components/modalNotification.js";
import customTheme from "@/config/POPTheme";
import { sound } from '@/plugins/soundEffect.js'


export default {
    name: 'KerryDropoff' ,
    props: {
        kerryDropoff: Object,
        count: Number,
        addressFrom: Object,
        cartKerryDropoff: Array
    },
    components:{
        SearchTracking
    },
    data(){
        const dropoffKerryOption = customTheme.dropoffKerryOption || {}
        return {
            isLoadCancelBatch: false,
            kerryOrder: [],
            batchId: '',
            customDropoff: {
                manual: dropoffKerryOption.manual,
                vdoHowTo: dropoffKerryOption.vdoHowTo,
            }
        }
    },
    methods:{
        async checkTrackingKerryDropoff(){
            this.kerryDropoff.isLoadingKerryDropoff = true

            if( !this.batchId ){
                await createBatch( this.addressFrom.tel ).then( res => {
                    this.batchId = res.batch_no;
                    if( res.items.length > 0 ){
                        sound('positiveBeep')
                        res.items.forEach( order => {
                            this.kerryOrder.push( this.setFormatOrderKerryDropoff( order ) );
                        })
                    }

                }).catch(e => {
                    sound('beepFail')
                    this.kerryDropoff.errorMsg = e;
                    this.kerryDropoff.isLoadingKerryDropoff = false
                });
            }

            if( (this.kerryOrder.length+this.cartKerryDropoff.length) > 99 ){
                sound('beepFail')
                this.kerryDropoff.errorMsg = `ไม่สามารถสร้างรายการ Shipment ได้ เนื่องจาก BatchId รองรับจำนวน Shipment ได้สูงสุด 100 Shipment`;
                this.kerryDropoff.isLoadingKerryDropoff = false
                return false
            }

            let uniqueTracking = this.kerryOrder.filter( kerry => {
                return kerry.dropoff_tracking_code === this.kerryDropoff.trackingCode
            })
            let uniqueCartTracking = this.cartKerryDropoff.filter( kerry => {
                return kerry.dropoff_tracking_code === this.kerryDropoff.trackingCode
            })

            if( uniqueTracking.length > 0 || uniqueCartTracking.length > 0 ){
                sound('beepFail')
                this.kerryDropoff.errorMsg = `ไม่สามารถสร้างรายการ Shipment ได้ เนื่องจากหมายเลขพัสดุ ${this.kerryDropoff.trackingCode} นี้ ถูกใช้งานไปแล้ว`;
                this.kerryDropoff.isLoadingKerryDropoff = false
                return false
            }

            await addShipment( this.batchId , this.kerryDropoff.trackingCode , this.count).then( res => {
                sound('positiveBeep')
                this.kerryOrder.push( this.setFormatOrderKerryDropoff( res ) );

                this.kerryDropoff.isLoadingKerryDropoff = false
                this.kerryDropoff.trackingCode = '';
            }).catch(e => {
                sound('beepFail')
                this.kerryDropoff.errorMsg = e;
                this.kerryDropoff.isLoadingKerryDropoff = false
            });
        },
        async deleteKerryOrder( kerryOrderByOne , indexOfOrder ){
            await deleteShipment( this.batchId , kerryOrderByOne.dropoff_tracking_code , kerryOrderByOne.consignment_no_ref ).then( res => {
                this.kerryOrder.splice( indexOfOrder , 1)
            }).catch(e => {
                showErrorModal( e );
            });
        },
        async clearKerryDropoff(){
            if( this.kerryOrder.length > 0 && this.cartKerryDropoff.length < 1){
                this.isLoadCancelBatch = true
                await deleteBatch( this.batchId ).then( res => {
                    this.kerryOrder = [];
                    this.batchId = "";
                    this.isLoadCancelBatch = false
                    this.closeKerryDropoff()
                    setLocalStorage.batchNo().set( "" );
                }).catch(e => {
                    this.isLoadCancelBatch = false
                    showErrorModal( e );
                });
            }else{
                this.kerryOrder.forEach( (order , index) => {
                    this.deleteKerryOrder( order , index )
                })
            }

           this.closeKerryDropoff()
        },
        closeKerryDropoff(){
            this.kerryDropoff.show = false
            this.kerryDropoff.trackingCode = '';
            this.kerryDropoff.errorMsg = '';
        },
        setFormatOrderKerryDropoff( kerryOrder ){
            let count = this.count

            let kerryDropoff = {
                error:{
                    status: false,
                    data: [],
                    msg: null
                },
                type : 'ship',
                dropoff_type : 'KERRY_DROPOFF',
                num : 1,
                name : 'KERRY DROPOFF',
                price : '0.00',
                rate_remote_area : '0.00',
                cross_price : '0.00',
                cod_amount : '0.00',
                dropoff_tracking_code: kerryOrder.consignment_no,
                consignment_no_ref: kerryOrder.consignment_no_ref,
                check : count++,
                from: {
                    name: this.addressFrom.name,
                    address: this.addressFrom.address,
                    district: this.addressFrom.district,
                    state: this.addressFrom.state,
                    province: this.addressFrom.province,
                    postcode: this.addressFrom.postcode,
                    tel: this.addressFrom.tel
                },
                to: {
                    name: kerryOrder.recipient_name,
                    address: '',
                    district: '',
                    province: '',
                    state:'',
                    postcode: kerryOrder.recipient_zipcode,
                    tel: '',
                }
            }

            this.$emit('update:count', count)

            return kerryDropoff
        }
    }
}
</script>
